import React from 'react';

function Search() {
  return (
    <svg
      id="icon-search"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Rectangle_258" data-name="Rectangle 258" width="24" height="24" fill="none" />
      <path id="icon-search-2" data-name="icon-search" d="M15.891,14.608l4.842,4.842a.908.908,0,1,1-1.285,1.283l-4.842-4.842a7.2,7.2,0,1,1,1.283-1.283ZM10.2,15.6a5.4,5.4,0,1,0-5.4-5.4A5.4,5.4,0,0,0,10.2,15.6Z" transform="translate(0.002 0.5)" fill="currentColor" />
    </svg>
  );
}

export { Search };
